import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { PolicyStatusSummaryRow } from '../../services/webFilter.service';
import WfDiffArrow from './WfDiffArrow';

ChartJS.register(CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title, Tooltip, Legend);

interface Props {
  rows: PolicyStatusSummaryRow[];
  chartItems: { exceptType: string; prev: number; current: number }[];
  isPdfMode?: boolean;
}

const PREV_COLOR = 'rgba(149, 165, 166, 0.8)';
const CURRENT_COLOR = 'rgba(52, 152, 219, 0.8)';

const WfPolicyStatus1: React.FC<Props> = ({ rows, chartItems, isPdfMode }) => {
  const totalRow = rows.find((r) => r.exceptType === '총합') ?? { prevCount: 0, currentCount: 0, diffText: '-' };
  return (
    <div className={`wf-section-card ${isPdfMode ? 'pdf-page-break' : ''}`}>
      {isPdfMode && <h2 className="wf-pdf-section-title">📋 정책 현황 (1/2)</h2>}
      <h3>■ 전월 대비 예외 신청 현황</h3>

      <div className="wf-chart-row">
        <div className="wf-chart-card">
          <div className="wf-chart-title">[예외 항목별 발생 건수 전월 대비 현황]</div>
          <div className="wf-chart-wrapper">
            <Bar
              data={{
                labels: chartItems.map((c) => c.exceptType),
                datasets: [
                  { label: '전월', data: chartItems.map((c) => c.prev), backgroundColor: PREV_COLOR },
                  { label: '당월', data: chartItems.map((c) => c.current), backgroundColor: CURRENT_COLOR },
                ],
              }}
              options={{
                responsive: true,
                maintainAspectRatio: false,
                plugins: { legend: { position: 'top' } },
                scales: { y: { beginAtZero: true, title: { display: true, text: '건수' } } },
              }}
            />
          </div>
        </div>

        <div className="wf-chart-card">
          <div className="wf-chart-title">[총 예외 건수 전월 대비 현황]</div>
          <div className="wf-chart-wrapper">
            <Bar
              data={{
                labels: ['전월', '당월'],
                datasets: [
                  {
                    label: '건수',
                    data: [totalRow.prevCount, totalRow.currentCount],
                    backgroundColor: [PREV_COLOR, CURRENT_COLOR],
                  },
                ],
              }}
              options={{
                responsive: true,
                maintainAspectRatio: false,
                plugins: { legend: { display: false } },
                scales: { y: { beginAtZero: true, title: { display: true, text: '건수' } } },
              }}
            />
          </div>
        </div>
      </div>

      <table className="wf-data-table">
        <thead>
          <tr>
            <th rowSpan={2}>구분</th>
            <th colSpan={2}>건수</th>
            <th rowSpan={2}>증감</th>
          </tr>
          <tr>
            <th>전월</th>
            <th>당월</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.exceptType} className={r.exceptType === '총합' ? 'wf-total-row' : ''}>
              <td>{r.exceptType}</td>
              <td>{r.prevCount.toLocaleString()}</td>
              <td>{r.currentCount.toLocaleString()}</td>
              <td><WfDiffArrow diffText={r.diffText} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default WfPolicyStatus1;
